import Chip from '@mui/material/Chip';
import { InputLabel, Switch } from '@mui/material';
import { Controller } from 'react-hook-form';

/**
 * PGSS-5714: "Sandblasted at plant". The supplier sandblasts the order's stone at its plant, so on receipt the order
 * skips warehouse sandblasting and its ETA has no local sandblasting time. One flag per order, set by staff; the
 * supplier sees it on its order (the API sends `sandblasted_at_plant` to staff and suppliers only).
 */
export const SANDBLASTED_AT_PLANT = 'Sandblasted at plant';

/** True when the order is marked sandblasted at the plant. */
export const isSandblastedAtPlant = (order) => order?.sandblasted_at_plant === true;

/** The order-form switch. Unset reads as off, so a new order starts as sandblasted in Columbus. */
export function SandblastedAtPlantSwitch({ control, disabled = false, className = 'mt-8', labelClassName = 'mt-8 ml-5' }) {
  return (
    <>
      <Controller
        name="sandblasted_at_plant"
        key="sandblasted_at_plant"
        control={control}
        render={({ field: { onChange, value } }) => (
          <Switch
            checked={value === true}
            onChange={(ev) => onChange(ev.target.checked)}
            className={className}
            id="sandblasted_at_plant_switch"
            inputProps={{ 'data-testid': 'sandblasted-at-plant-switch' }}
            size="small"
            disabled={disabled}
          />
        )}
      />
      <InputLabel htmlFor="sandblasted_at_plant_switch" className={labelClassName}>
        {SANDBLASTED_AT_PLANT}
      </InputLabel>
    </>
  );
}

/** Shown on the order for staff and the supplier; nothing when the order is sandblasted here. */
export function SandblastedAtPlantChip({ order, size = 'small', className = '' }) {
  if (!isSandblastedAtPlant(order)) {
    return null;
  }
  return (
    <Chip
      size={size}
      color="secondary"
      variant="outlined"
      label={SANDBLASTED_AT_PLANT}
      className={className}
      data-testid="sandblasted-at-plant-chip"
    />
  );
}
